// extracted by mini-css-extract-plugin
export default {"noWrapText":"publishing-smart-tv-panel-module__noWrapText--oFOqz"};